import React, { Component } from "react";
import { Link } from "react-router-dom";

class HeroImage extends Component {
  render(props) {
    return <h1 className="headline">{this.props.content}</h1>;
  }
}
export default HeroImage;
